import { useMemo } from "react";
import getConfig from "next/config";

import { useTranslation } from "@lib/i18n";
import { useConfigurationSelector } from "@redux/reducers/appConfig";
import {
  useCarConfigurationSelector,
  useFinanceSimulationSelector,
  useSalesmanSelector,
  useBusinessModelSelector,
  useIsScrappageSelectedSelector,
} from "@redux/reducers/deal";
import { getIsMultilingualMarket } from "@components/administration/helpers/isMultilingualMarket";
import { DEEP_LINK_DEFAULT } from "@shared/constants";

const { publicRuntimeConfig } = getConfig();
const { COUNTRY, ROOT_URL_PREFIX } = publicRuntimeConfig;

export const useDeeplinkPathname = ({ journeyOverride } = {}) => {
  const { i18n } = useTranslation();
  const appConfiguration = useConfigurationSelector();
  const selectedBusinessModel = useBusinessModelSelector();
  const isScrappageSelected = useIsScrappageSelectedSelector();
  const selectedSalesman = useSalesmanSelector();
  const { journey: selectedJourney } = useFinanceSimulationSelector();
  const {
    preconfiguration: selectedPreconfiguration,
    accessory: selectedAccessories,
    service: selectedServices,
  } = useCarConfigurationSelector();

  const journey = journeyOverride || selectedJourney;
  const isMultilingualMarket = useMemo(
    () => getIsMultilingualMarket(COUNTRY),
    []
  );

  return useMemo(() => {
    if (!selectedPreconfiguration) {
      return ROOT_URL_PREFIX || "/";
    }

    const queryParams = [
      `journey=${journey}`,
      `businessModel=${selectedBusinessModel}`,
      `preconfiguration=${selectedPreconfiguration.id}`,
      ...(selectedAccessories || []).map(
        i => `accessories=${i.officialReference}`
      ),
      selectedServices?.[0] && `service=${selectedServices[0].id}`,
      isMultilingualMarket && `language=${i18n.language}`,
      selectedSalesman && `salesman=${selectedSalesman}`,
      isScrappageSelected && `isScrappageSelected=${isScrappageSelected}`,
    ]
      .filter(Boolean)
      .join("&");

    const deeplinkPath =
      appConfiguration.app.deeplinks?.pathname || DEEP_LINK_DEFAULT;

    return `${ROOT_URL_PREFIX || ""}/${deeplinkPath}?${queryParams}`;
  }, [
    journey,
    selectedBusinessModel,
    selectedPreconfiguration,
    selectedAccessories,
    selectedServices,
    isMultilingualMarket,
    i18n.language,
    selectedSalesman,
    isScrappageSelected,
    appConfiguration.app.deeplinks,
  ]);
};
